import {
  GET_SERVICE_MODE_TYPES_LIST,
  SET_CARGO_DETAILS_TYPES_LIST,
  SET_CARGO_MATERIAL_PACKING_TEMAPLATE,
  SET_CONSIGNOR_PICKUP_LOCATION_LIST,
  SET_HANDLING_INSTRUCTION_TYPES_LIST,
  SET_PACKING_TYPES_LIST,
  SET_SERVICE_MODE_TYPES_LIST,
  SET_SERVICE_TYPES_LIST,
  SET_SUPPLIER_DETAILS_RFQ,
  SET_VEHICLE_TYPES_LIST,
} from "Constants/actionConstants";

const initialState = {
  consignorPickupLocationList: [],
  serviceTypesList: [],
  serviceModeTypesList: [],
  cargoDetailsTypesList: [],
  cargoMaterialPackingTemaplateLink: "",
  handlingInstructionTypesList: [],
  vehicleTypesList: [],
  packingTypesList: [],
  supplierDetailsRfq:{}
};

const supplierRFQCreateOrUpdateRequest = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CONSIGNOR_PICKUP_LOCATION_LIST: {
      return {
        ...state,
        consignorPickupLocationList: payload,
      };
    }

    case SET_SERVICE_TYPES_LIST: {
      return {
        ...state,
        serviceTypesList: payload,
      };
    }

    case SET_SERVICE_MODE_TYPES_LIST: {
      return {
        ...state,
        serviceModeTypesList: payload,
      };
    }

    case SET_CARGO_DETAILS_TYPES_LIST: {
      return {
        ...state,
        cargoDetailsTypesList: payload,
      };
    }

    case SET_CARGO_MATERIAL_PACKING_TEMAPLATE: {
      return {
        ...state,
        cargoMaterialPackingTemaplateLink: payload,
      };
    }
    case SET_HANDLING_INSTRUCTION_TYPES_LIST: {
      return {
        ...state,
        handlingInstructionTypesList: payload,
      };
    }
    case SET_VEHICLE_TYPES_LIST: {
      return {
        ...state,
        vehicleTypesList: payload,
      };
    }
    case SET_PACKING_TYPES_LIST: {
      return {
        ...state,
        packingTypesList: payload,
      };
    }
    
    case SET_SUPPLIER_DETAILS_RFQ: {
      return {
        ...state,
        supplierDetailsRfq: payload,
      };
    }

    default:
      return state;
  }
};

export default supplierRFQCreateOrUpdateRequest;
